var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgN6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #005799;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.85,32.5c0-5.61,1.09-9.81,3.27-12.59,2.18-2.78,5.41-4.17,9.68-4.17,1.47,0,2.63.12,3.48.37v2.79c-1-.33-2.15-.49-3.44-.49-3.06,0-5.4.95-7.01,2.86-1.62,1.91-2.5,4.91-2.66,8.99h.23c1.43-2.24,3.7-3.36,6.8-3.36,2.56,0,4.59.77,6.06,2.32,1.48,1.55,2.22,3.65,2.22,6.31,0,2.97-.81,5.3-2.43,7s-3.81,2.55-6.57,2.55c-2.96,0-5.3-1.11-7.03-3.33-1.73-2.22-2.6-5.31-2.6-9.27Zm9.59,9.84c1.85,0,3.28-.58,4.31-1.75,1.02-1.17,1.53-2.85,1.53-5.05,0-1.89-.48-3.37-1.43-4.45-.95-1.08-2.37-1.62-4.26-1.62-1.17,0-2.25.24-3.22.72s-1.75,1.15-2.33,1.99c-.58.85-.87,1.73-.87,2.64,0,1.34.26,2.59.78,3.75.52,1.16,1.26,2.08,2.22,2.75s2.05,1.02,3.27,1.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN6);
export default __webpack_public_path__ + "static/media/n6.e7b42e03f6db1ee1193fceaaed5c65a0.svg";
export { ForwardRef as ReactComponent };